export {
  DEFAULT_INPUT_LIMITS,
  InputValidationError,
  MAX_FILE_BYTES,
  MAX_IMAGE_DIMENSION,
  MAX_IMAGE_PIXELS,
  sanitizeArtifactFilename,
  validateInputDescriptor,
  type InputDescriptor,
  type InputErrorCode,
  type InputValidationLimits,
  type ValidatedInput,
} from './file-validation.js';

export interface ArtifactInput {
  bytes: Uint8Array;
  filename: string;
  declaredMediaType: string;
  detectedMediaType: string;
}

export interface AdapterContext {
  verificationId: string;
  startedAt: string;
  signal?: AbortSignal;
}

export interface CapabilityDescriptor {
  id: string;
  label: string;
  mediaTypes: readonly string[];
  state: 'SUPPORTED' | 'NOT_CHECKED' | 'NOT_SUPPORTED';
  description: string;
  available: boolean;
  local: boolean;
}

export class CapabilityRegistry {
  readonly #capabilities = new Map<string, CapabilityDescriptor>();

  register(capability: CapabilityDescriptor): void {
    if (this.#capabilities.has(capability.id)) {
      throw new Error(`Capability already registered: ${capability.id}`);
    }
    this.#capabilities.set(capability.id, Object.freeze({ ...capability }));
  }

  list(): readonly CapabilityDescriptor[] {
    return [...this.#capabilities.values()];
  }

  supports(mediaType: string): boolean {
    return this.list().some(
      ({ available, mediaTypes }) => available && mediaTypes.includes(mediaType),
    );
  }
}

export function stableEvidenceId(prefix: string, source: string): string {
  let hash = 2_166_136_261;
  for (const character of source) {
    hash ^= character.codePointAt(0) ?? 0;
    hash = Math.imul(hash, 16_777_619);
  }
  return `${prefix}:${(hash >>> 0).toString(36)}`;
}
